

import { useEffect, useState } from "react";
import { FaCheckCircle, FaChevronDown, FaChevronUp, FaTimesCircle } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import { NavLink } from "react-router";
import { IMAGE_URL, REACT_APP_API_PORT } from "../../../Api";
import axios from "axios";
export default function MembershipCard2() {
  // const plans = [
  //   {
  //     title: "NextFuture AI - Viral Mastery",
  //     originalPrice: "₹6000",
  //     price: "₹3490",
  //     type: "Yearly",
  //     planMonthly: "💰 ₹349/month ( One-time yearly billing)",
  //     buttonText: "Join Now",
  //     buttonLink:
  //       "https://learn.nextfutureai.in/web/checkout/68d0f9b2cd599a190a308605",
  //     benefits: [
  //       // "1000+ Ready-to-Use AI Prompts (save time)",
  //       "Weekly 3 Viral Video Tutorials (easy & practical)",
  //       "Get 20% Additional Discount of All AI Courses",
  //       "Weekly Live Q&A with Satyam (get your doubts cleared)",
  //       "Private WhatsApp Community Access (exclusive group)",
  //       "Direct WhatsApp Support (quick help when you need it)",
  //       "1 Free AI Course Module (bonus learning pack)",
  //       "1 Free 1:1 Strategy Call (personal growth roadmap)",
  //     ],
  //     image:'/images/profilepage/yearly_plan.png',
  //     bestValue: true, // highlight yearly plan
  //     bestValueText: "Best Value 💎"
  //   },
  //   {
  //     title: "NextFuture AI - Viral Mastery",
  //     originalPrice: "₹1500",
  //     price: "₹1047",
  //     type: "Quarterly",
  //     planMonthly: "💰 ₹349/month (billed every 3 months)",
  //     buttonText: "Join Now",
  //     buttonLink:
  //       "https://learn.nextfutureai.in/l/6de3f09e24",
  //     benefits: [
  //       // "1000+ Ready-to-Use AI Prompts (save time)",
  //       "Weekly 3 Viral Video Tutorials (easy & practical)",
  //       "Get 10% Additional Discount of All AI Courses",
  //       "Weekly Live Q&A with Satyam (get your doubts cleared)",
  //       "Private WhatsApp Community Access (exclusive group)",
  //       "Direct WhatsApp Support (quick help when you need it)",
  //     ],
  //     notIncluded: [
  //       "1 Free AI Course Module (bonus learning pack)",
  //       "1 Free 1:1 Strategy Call (personal growth roadmap)",
  //     ],
  //      image:'/images/profilepage/quarterly_plan.png',
  //     bestValue: true,
  //     bestValueText: "Starter Plan 🎯",
  //   },

  // ];

  const [plans, setPlans] = useState([])
  const [isLoading, setisLoading] = useState(false)

  const getData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/active-membership-details`);
      setisLoading(false);
      if (res.data.status) {
        setPlans(res.data.data);
      }

    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Track toggle state for all cards (array of booleans)
  const [openStates, setOpenStates] = useState(plans.map(() => false));

  const toggleContent = (idx) => {
    setOpenStates((prev) =>
      prev.map((isOpen, i) => (i === idx ? !isOpen : isOpen))
    );
  };

  useEffect(() => {
    if (plans.length > 0) {
      setOpenStates(plans.map(() => false));
    }
  }, [plans]);

  const getBadgeClass = (color) => {
    switch (color) {
      case "golden-gradient":
        return "bg-gradient-to-r from-[#C6972E] via-[#F6E492] to-[#C6972E] text-black";
      case "purple-gradient":
        return "bg-gradient-to-r from-purple-400 via-purple-500 to-purple-700 text-white";
      case "blue-gradient":
        return "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 text-white";
      default:
        return "bg-gray-300 text-black"; // fallback
    }
  };
  return (
    <div className=" bg1-gray-100  flex flex-col items-center py-5 lg:py-10">
      {/* <h1 className="text-3xl font-bold mb-">Membership Plans</h1>
      <p className="text-md text-gray-600 mb-6 lg:mb-8">
        Enroll Yearly <span className="">(Get 1 Course Free)</span>
      </p> */}

      {/* <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2 items-start"> */}
      <div
        className={`
          grid gap-8 items-start
          ${
            plans.length === 2
              ? "grid-cols-1 md:grid-cols-2 justify-center"
              : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
          }
        `}
>
        {plans && plans.map((plan, idx) => (
          <div
            key={idx}
            className="relative bg1-white bg-black/40 border border-gray-700 shadow-[0_0_40px_rgba(0,170,255,0.15)] transition-transform hover:scale-[1.02] backdrop-blur-md  rounded-2xl w-100 lg:min-w-[420px] hover:shadow-xl transition"
          >
            {/* Best Value Badge */}
            {/* {plan.badge_name &&
              (
                <>

                  {plan.type === 'Quarterly' && (
                    <span className="absolute -top-3 -left-2 z-10 bg-gradient-to-r from-purple-400 via-purple-500 to-purple-700 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                      {plan.badge_name}
                    </span>
                  )}



                  {plan.type === "Yearly" && (
                    <span className="absolute -top-3 -left-2 z-10 bg-gradient-to-r from-[#C6972E] via-[#F6E492] to-[#C6972E] text-black text-xs font-bold px-3 py-1 rounded-full shadow-md">
                      {plan.badge_name}
                    </span>
                  )}
                </>
              )} */}

            {plan.badge_name && (
              <span
                className={`absolute -top-3 -left-2 z-10 text-xs font-bold px-3 py-1 rounded-full shadow-md ${getBadgeClass(plan.badge_color)}`}
              >
                {plan.badge_name}
              </span>
            )}


            {/* Banner */}
            {
              (plan.image) && <a
                href={plan.membership_link}
                target="_blank"
              >
                <img
                  src={IMAGE_URL + plan.image}
                  onError={(e) => {
                    e.target.src = "placeholder-image.png"
                  }}
                  alt={plan.name}
                  className="w-full h-48 lg:h-60 object-cover rounded-t-xl"
                />
              </a>
            }



            {/* Content */}
            <div className="px-3 py-2 text-white">
              <h2 className="text-xl font-bold text-white ">{plan?.name}</h2>

              {/* Price with cutting original */}
              <div className="flex items-center gap-2 mt-1">
                {
                  (plan.original_price) && <span className="text-lg text-gray-500 line-through">
                    ₹{plan.original_price}
                  </span>
                }




                {/* {
                  (plan.selling_price) && <span className="text-2xl font-semibold text-gray-900">
                    ₹{plan.selling_price}
                  </span>
                } */}

                {
                  (plan.selling_price) && <span className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#00C6FF] drop-shadow-md">
                    ₹{plan.selling_price} <span className="text-xl text-white"></span>
                  </span>
                }


                {plan.type && (
                  <span className="text-xs text-gray-400">({plan?.type})</span>
                )}
              </div>

              <p className="text-sm text-white">{plan.billing_note}</p>


              {plan.membership_link ? (
                <a
                  href={plan.membership_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-full  text-white py-2 mt-2 rounded-full bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition"
                >
                  <span>{plan.button_name}</span>
                  {/* <FaArrowRightLong className="ml-2" /> */}
                </a>
              ) : (
                <button
                  disabled
                  className="flex items-center justify-center w-full bg-gray-300 text-white py-2 mt-2 rounded-full cursor-not-allowed"
                >
                  <span>{plan.button_name}</span>
                  {/* <FaArrowRightLong className="ml-2" /> */}
                </button>
              )}

              <button
                onClick={() => toggleContent(idx)}
                className="w-full flex items-center justify-center gap-1 bg1-gray-100 border1 mt-2 py-2 rounded-lg text-white text-sm hover:bg1-gray-200 transition"
              >
                {openStates[idx] ? (
                  <>
                    Show Less <FaChevronUp />
                  </>
                ) : (
                  <>
                    Show More <FaChevronDown />
                  </>
                )}
              </button>


              {/* Toggle Content */}
              {openStates[idx] && (
                <div>
                  {/* Included Benefits */}
                  <div>
                    <p className="mx-0 px-0 mt-3 font-semibold text-md">
                      🎁 Enroll Now & Instantly Unlock:
                    </p>
                    <ul className="mt-2 space-y-2 text-sm text-gray-200">
                      {plan.features.map((benefit, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <FaCheckCircle className="text-green-500 mt-1" />
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Not Included */}
                  {plan.excluded_features && plan.excluded_features.length > 0 && (
                    <div>
                      <ul className="mt-2 mb1-2 space-y-2 text-sm text-gray-400">
                        {plan.excluded_features.map((item, i) => (
                          <li key={i} className="flex items-start gap-2">
                            <FaTimesCircle className="text-red-500 mt-1" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
